import { render, staticRenderFns } from "./Downloadd.vue?vue&type=template&id=3c8c5e0c&"
import script from "./Downloadd.vue?vue&type=script&lang=js&"
export * from "./Downloadd.vue?vue&type=script&lang=js&"
import style0 from "./Downloadd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports